"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("./Icon");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledIcon__IconWrapper",
  componentId: "sc-1icyav-0"
})(["", ""], function (props) {
  var fillColor = _tokens.default.sky.sys.color.iconfill.ondark;
  var hoverFill = _tokens.default.sky.sys.color.iconfill.onlight;
  var hoverBackgroundColor = _tokens.default.sky.sys.color.background.primary[1];
  var borderRadius = _tokens.default.sky.sys.size.borderradius[2];
  return "\n      svg {\n        path {\n          fill: ".concat(fillColor, ";\n        }\n      }\n\n      &:hover {\n        cursor: pointer;\n        ").concat(props.changeOnHover ? "\n          background-color: ".concat(hoverBackgroundColor, ";\n          svg {\n            path {\n              fill: ").concat(hoverFill, ";\n            }\n          }\n          border-radius: ").concat(borderRadius, ";\n          ") : '', "\n      }\n    ");
});
var StyledIcon = function StyledIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconWrapper, {
    changeOnHover: props.changeOnHover,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread({}, props))
  });
};
exports.StyledIcon = StyledIcon;